<script>
  import ToggleInput from "@/components/atoms/ToggleInput.vue";

  export default {
    name: "ConferencePolice",
    components: { ToggleInput },
    props: {
      policy: { type: Object, default: () => ({}) },
      user: { type: Object, default: () => ({}) },
    },
    data() {
      return {
        enabled: !!(this.user.polices && this.user.polices[this.policy.key] && this.user.polices[this.policy.key].status),
      };
    },
    methods: {
      handleToggleChange(value) {
        this.enabled = value;
        this.$emit("result-updated", { politic: value });
      },
    },
  };
</script>
<template>
  <div class="conferencePolice">
    <div class="conferencePolice__content">
      <p class="conferencePolice__title">Chat conferencia de monitores</p>
      <p class="conferencePolice__description">Controla el acceso al chat de conferencia de los monitores. Habilítalo únicamente para usuarios que deban participar en estas conversaciones.</p>
    </div>
    <ToggleInput :value="enabled" @input="handleToggleChange" label="" />
  </div>
</template>
<style lang="scss">
  .conferencePolice {
    @include Flex(row, space-between, flex-start);
    width: 100%;
    gap: 12px;
    padding: 12px 0;

    &__content {
      @include Flex(column, flex-start, flex-start);
      gap: 4px;
    }

    &__title {
      font-size: 16px;
      font-family: $newFont_medium;
      font-weight: 500;
      color: #3d3d3d;
    }

    &__description {
      font-size: 13px;
      font-family: $newFont_regular;
      color: #595959;
    }
  }
</style>
